import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Giftwrap from "./Giftwrap";
import FAQ from "./FAQs/FAQ"
import Personalisation from "./Personalisation";
import Contact from "./Contact";
import Reviews from "./Reviews";
import OurStory from "./OurStory/OurStory";
import Terms from "./Terms";
import PhotoGallery from "./PhotoGallery";
import Partners from "./Partners";
import Blog from "./Blog";
import Sustainability from "./Sustainability";
import styles from './CustomerServiceDetails.module.css'
import Popups from "./Popups/Popups";
import ContactUs from "./ContactUs/ContactUs";

function CustomerServiceDetails() {
  const { info } = useParams();

  const pages = [
    { Name: "Giftwrap", Page: <Giftwrap /> },
    { Name: "FAQ", Page: <FAQ /> },
    { Name: "Personalisation", Page: <Personalisation /> },
    { Name: "Contact", Page: <ContactUs /> },
    { Name: "Reviews", Page: <Reviews /> },
    { Name: "OurStory", Page: <OurStory /> },
    { Name: "Terms", Page: <Terms /> },
    { Name: "PhotoGallery", Page: <PhotoGallery /> },
    { Name: "Partners", Page: <Partners /> },
    { Name: "Blog", Page: <Blog /> },
    { Name: "Sustainability", Page: <Sustainability /> },
    {Name: "Popups", Page: <Popups /> }
  ];

  const Page = pages.find((page) => page.Name === info);

  if (!Page) {
    return <Navigate to="/Customer-Services" />;
  }

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Header}>        
      </div>
      {Page.Page}
    </div>
  );
}

export default CustomerServiceDetails;
